import { render, staticRenderFns } from "./PillTabs.vue?vue&type=template&id=763b4ec6"
import script from "./PillTabs.vue?vue&type=script&lang=js"
export * from "./PillTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports